import type { ComputedRef, InjectionKey } from 'vue'

/** Gallery context key resolved from the product-list route (e.g. `"mens"`, `"womens"`). */
export const GalleryContextKey: InjectionKey<ComputedRef<string | undefined>> = Symbol('GalleryContext')
